
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 下载模板
export function downLoadFile (url) {
  return axios({
    url: sysInfo.apiRemote + '/common/file?path=' + url,
    method: 'GET',
    responseType: 'blob',
    timeout: 5 * 60 * 1000
  })
}
// 收票附件下载
export function downLoadFileSp (url) {
  return axios({
    url: sysInfo.apiRemote + '/invoice/file/' + url,
    method: 'GET',
    responseType: 'blob',
    timeout: 5 * 60 * 1000
  })
}
